export const marketType = {
    "Ephemeral": "Ephemeral",
    "Persistent": "Persistent",
    "Dedicated": "Dedicated",
    "Template": "Template"
} as const;
export type MarketType = (typeof marketType)[keyof typeof marketType];